import axios from "axios";
export default async function getApiResponse(config) {     
  let type=typeof config;
  let timeOut=59000
  const isGoldenticketRequest =
    typeof window !== "undefined" && window.isGoldenticket?.();
  const goldenTicketHeader = isGoldenticketRequest
    ? { channel: "GOLDEN_TICKET" }
    : {};

  let response 
  try {
    response =
      type == "string"
        ? await axios(config, {
            timeout: timeOut,
            headers: { ...goldenTicketHeader },
          })
        : await axios({
            ...config,
            timeout: timeOut,
            headers: {
              ...(config?.headers || {}),
              ...goldenTicketHeader,
            },
          });
    
      if (response.status !== 200) {
        return null;        

      } else {         
        const data = await response.data;
        return data;
      }
    
  }catch(err){
    console.log(err);
    if (err?.code == "ECONNABORTED" || err?.message?.includes("timeout of 59000ms exceeded") || (err?.response?.status == 504) || err?.message?.includes("timeout of 57000ms exceeded")) {
      return "error";
    }
    // Return error object for better error handling
    if (err?.response) {
      return {
        error: true,
        message: err.response.data?.message || err.response.data?.error || `Request failed with status ${err.response.status}`,
        status: err.response.status
      };
    }
    return {
      error: true,
      message: err?.message || "An unexpected error occurred. Please try again."
    };
  }     
}